<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    if (this.$extension) {
      this.$extension.window.startAutoResizer();
    }
  },
  destroyed() {
    if (this.$extension) {
      this.$extension.window.stopAutoResizer();
    }
  },
};
</script>

<style lang="scss">
  body {
    margin: 0;
    overflow: hidden;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .4s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
